/**
 * Square integration client. connect/status are GETs (the consolidated
 * /api/square fn routes by ?action=), so they don't use apiFetch (which POSTs).
 * The shop is resolved server-side from the authenticated owner — no shopId here.
 */
import { getSessionId } from './api-client';

function authHeaders(): Record<string, string> {
  const sessionId = getSessionId();
  return sessionId ? { Authorization: `Bearer ${sessionId}` } : {};
}

export interface SquareStatus {
  connected: boolean;
  merchant_id: string | null;
  connected_at: string | null;
}

/** Ask the backend for the Square OAuth authorize URL, then send the browser there. */
export async function startSquareConnect(): Promise<void> {
  const res = await fetch('/api/square?action=connect', { headers: authHeaders() });
  if (!res.ok) {
    const e = await res.json().catch(() => ({}));
    throw new Error(e.error || `Square connect failed (${res.status})`);
  }
  const { url } = await res.json();
  if (!url) throw new Error('No authorize URL returned');
  window.location.href = url;
}

export async function getSquareStatus(): Promise<SquareStatus> {
  const res = await fetch('/api/square?action=status', { headers: authHeaders() });
  if (!res.ok) throw new Error(`Square status failed (${res.status})`);
  return res.json();
}

export interface CatalogStampItem {
  id: string; name: string; category: string | null; variationIds: string[]; suggested: boolean;
}

/** Owner's Square catalog items, for the stamp-eligible-items picker. */
export async function getSquareCatalogItems(): Promise<CatalogStampItem[]> {
  const res = await fetch('/api/square?action=catalog-items', { headers: authHeaders() });
  if (!res.ok) throw new Error(`Square catalog fetch failed (${res.status})`);
  const body = await res.json();
  return (body.items || []) as CatalogStampItem[];
}
